import '../../balance/invoices/invoice.scss';

import classnames from 'classnames';
import { string } from 'prop-types';
import React from 'react';
import { Badge } from 'reactstrap';

import { statusColor } from '../utils';

function StatusBadge({ status, className }) {
  return (
    <Badge
      pill
      color={statusColor(status)}
      className={classnames('inv-status-badge', className)}
    >
      {status}
    </Badge>
  );
}

StatusBadge.propTypes = {
  status: string.isRequired,
  className: string,
};

StatusBadge.defaultProps = {
  className: '',
};

export default StatusBadge;
